import { io } from "socket.io-client";

const socket = io(process.env.REACT_APP_API_SERVER, {
    autoConnect: false,
});

socket.on("connect", () => {
    console.log("[socket] connected:", socket.id);
});

socket.on("disconnect", (reason) => {
    console.log("[socket] disconnected:", reason);
});

socket.on("connect_error", (err) => {
    console.log("[socket] connect_error:", err.message);
});

export default socket;
